import React, { useEffect, useState } from 'react';
import { DocumentDownload } from './DocumentDownload';
import { IframeContent } from './IframeContent';

export const DocumentContent: React.FC<{
  src: string;
  title: string;
}> = ({ src, title }) => {
  const [isPdfEnabled, setIsPdfEnabled] = useState(true);

  useEffect(() => {
    setIsPdfEnabled(window?.navigator?.pdfViewerEnabled);
  }, []);

  return (
    <>
      {isPdfEnabled ? (
        <IframeContent src={src} title={title} />
      ) : (
        <DocumentDownload src={src} title={title} />
      )}
    </>
  );
};
